import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { FiX, FiKey, FiHome, FiStar, FiDollarSign } from 'react-icons/fi';

import './styles.css';

const Menu = () => {
    const closeDrawer = () => {
        document.querySelector('#drawer-menu-overlay').classList.add('no-overlay');
        document.querySelector('#drawer-menu').classList.add('no-drawer-menu');
    }

    return(
        <Fragment>
            <div id="drawer-menu-overlay" className="overlay no-overlay" onClick={closeDrawer}></div>
            <div id="drawer-menu" className="drawer-menu no-drawer-menu">
                <FiX 
                    size={20}
                    color={'var(--color-white)'}
                    onClick={closeDrawer} 
                    style={{cursor:'pointer', margin: '0 10px 10px'}}
                />

                <div className="box-buttons">
                    <Link to='/venda/apartamento/fortaleza' onClick={closeDrawer}>
                        <FiHome />
                        Imóveis à venda
                    </Link>

                    <Link to='/aluguel/apartamento/fortaleza' onClick={closeDrawer}>
                        <FiKey />
                        Imóveis para alugar
                    </Link>

                    <Link to={'/venda/categoria/construcao'} onClick={closeDrawer}>
                        <i className="far fa-building" />
                        Destaques de vendas
                    </Link>

                    <Link to='/aluguel/categoria/alto-padrao' onClick={closeDrawer}>
                        <FiStar />
                        Destaque de aluguel
                    </Link>                                       
                </div>

                <hr/>

                <div className="box-services">
                    <Link to='/favoritos' onClick={closeDrawer}>
                        <i className="far fa-heart"></i>
                        Favoritos
                    </Link>
                    <Link to='/comparativos' onClick={closeDrawer}>
                        <i className="far fa-clone" />
                        Comparativos
                    </Link>                    
                </div>

                <hr/>

                <div className="box-buttons">                   
                    <Link to="/cadastre-seu-imovel" onClick={closeDrawer}>
                    <i className="fas fa-desktop" />
                        Anunciar meu imóvel
                    </Link>

                    <Link to={{pathname: process.env.REACT_APP_LOGIN}} target='_blank' onClick={closeDrawer}>
                    <i className="fas fa-barcode" />
                        Segunda via de boleto
                    </Link>

                    <Link to={{pathname: process.env.REACT_APP_LOGIN}} target='_blank' onClick={closeDrawer}>
                        <i className="far fa-calendar-check" />
                        Prestação de contas
                    </Link>

                    <Link to={{pathname: process.env.REACT_APP_LOGIN}} target='_blank' onClick={closeDrawer}>
                        <FiDollarSign />
                        Extrato de IRRF
                    </Link>                                       
                </div>
            </div>
        </Fragment>
    );
}

export default Menu;